import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import { noop } from 'ui-components/default-props/noop';
import { DateService } from '../../../services/date-service';
import { INLINE_MESSAGE_TYPES } from '../inline-message';
import { getTimes } from './helpers';

export const TimePicker = ({
  className = null,
  disabled = false,
  endTime = 24,
  hasError = false,
  id,
  inlineMessage = '',
  minuteIncrementUnit = 0,
  onBlur = noop,
  onTimeSelected = noop,
  selectedValue = '12:00 AM',
  startTime = 0,
  timeFormat = DateService.getDefaultTimeFormat(),
  togglerClassName = '',
}) => {
  const times = useMemo(
    () =>
      getTimes({
        endTime,
        minuteIncrementUnit,
        startTime,
        timeFormat,
      }),
    [endTime, minuteIncrementUnit, startTime, timeFormat],
  );

  const selectedTime = useMemo(() => times.find((t) => t.value === selectedValue), [times, selectedValue]);

  return (
    <DropdownMenu
      className={className}
      disabled={disabled}
      dropdownMenuShouldHaveWidthOfButton
      hasError={hasError}
      id={id}
      inlineMessage={inlineMessage}
      inlineMessageType={hasError ? INLINE_MESSAGE_TYPES.error : ''}
      onBlur={onBlur}
      variant='form'
    >
      <DropdownMenuToggler className={togglerClassName}>
        {selectedTime?.display || <FormattedMessage defaultMessage='Select time' description='select a time default value' id='dDOTrV' />}
      </DropdownMenuToggler>
      {times.map((time) => (
        <DropdownMenuItem key={time.value} name={time.value} onClick={onTimeSelected}>
          {time.display}
        </DropdownMenuItem>
      ))}
    </DropdownMenu>
  );
};

TimePicker.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  endTime: PropTypes.number,
  hasError: PropTypes.bool,
  id: PropTypes.string.isRequired,
  inlineMessage: PropTypes.node,
  minuteIncrementUnit: PropTypes.number,
  onBlur: PropTypes.func,
  onTimeSelected: PropTypes.func,
  selectedValue: PropTypes.string,
  startTime: PropTypes.number,
  timeFormat: PropTypes.string,
  togglerClassName: PropTypes.string,
};
